if (!customElements.get("club-subscribe")) {
  class ClubSubscribe extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.hydrateHeaderLogo();
    }

    hydrateHeaderLogo() {
      const logoTarget = this.querySelector("[data-club-subscribe-logo]");
      const headerLogo =
        document.querySelector(
          "#logo .logo-img:not(.logo-alt-img) img",
        ) || document.querySelector("#logo .logo-txt");

      if (!logoTarget || !headerLogo) {
        return;
      }

      const logo = headerLogo.cloneNode(true);
      logo.removeAttribute("class");
      logo.removeAttribute("style");
      logo.removeAttribute("tabindex");
      logo.removeAttribute("loading");

      if (logo instanceof HTMLAnchorElement) {
        logo.className = "club-subscribe__logo-text";
        logo.removeAttribute("href");
      }

      logoTarget.replaceChildren(logo);
    }
  }

  customElements.define("club-subscribe", ClubSubscribe);
}
